import { colors, font, spacing, ChevronIcon } from '@chegg-ui/theme';
import styled, { css } from 'styled-components';
export var AccordionHeading = styled.h2.withConfig({
  componentId: "v1s7mf-0"
})(["margin:0;min-height:2.5rem;position:relative;"]);
export var AccordionControl = styled.button.withConfig({
  componentId: "v1s7mf-1"
})(["position:absolute;height:100%;width:100%;background-color:", ";color:inherit;border:0;margin:0;padding:0;padding-left:", ";padding-right:", ";font-size:", ";font-family:", ";display:flex;align-items:center;justify-content:space-between;&:hover{background-color:", ";}", " ", ""], colors.white, spacing.px16, spacing.px8, font.size.px16, font.family["default"], colors.greyXlight, function (_ref) {
  var nested = _ref.nested;
  return nested ? css(["background-color:", ";&:hover,&:focus{background-color:", ";}"], colors.royalXlight, colors.royalLight) : '';
}, function (_ref2) {
  var isActive = _ref2.isActive;
  return isActive ? '' : "border-bottom: 1px solid ".concat(colors.greyLight, ";");
});
export var AccordionContainer = styled.div.withConfig({
  componentId: "v1s7mf-2"
})(["width:100%;font-family:", ";", " ", ""], font.family["default"], function (_ref3) {
  var hideFocusOutlineStyle = _ref3.hideFocusOutlineStyle;
  return hideFocusOutlineStyle ? "\n    outline: none;\n    & * {\n      outline: none;\n    }\n" : '';
}, function (_ref4) {
  var nested = _ref4.nested;
  return nested ? css(["background-color:", ";margin:", " ", ";width:calc(100% - ", ");"], colors.royalXlight, spacing.px16, spacing.px32, spacing.px64) : '';
});
export var SpacedChevron = styled(ChevronIcon).withConfig({
  componentId: "v1s7mf-3"
})(["margin-left:", ";"], spacing.px8);
export var AccordionPanel = styled.div.withConfig({
  componentId: "v1s7mf-4"
})(["display:none;", " ", ""], function (_ref5) {
  var isActive = _ref5.isActive;
  return isActive ? "\n    display: block;\n    border-bottom: 1px solid ".concat(colors.greyLight, ";\n    ") : '';
}, function (_ref6) {
  var nested = _ref6.nested;
  return nested ? css(["background-color:", ";"], colors.white) : '';
});